// helpers/rutaRemitocs.js
import axios from "axios";

const BASE = (import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com").replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE });
const p = (s) => String(s || "").replace(/^\/+/, "");
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};
const log = (url) => console.log("👉 URL:", API.getUri({ url }));

// ✅ LISTAR (GET /remitocs)
export const getRemitocs = async () => {
  const url = p("remitocs"); log(url);
  const { data } = await API.get(url, auth());
  // Backend responde: { ok, remitosc, cantidad }
  return Array.isArray(data?.remitosc) ? data.remitosc : (Array.isArray(data) ? data : []);
};

// ✅ OBTENER POR ID (GET /remitocs/:id)
export const getRemitocById = async (id) => {
  const url = p(`remitocs/${id}`); log(url);
  const { data } = await API.get(url, auth());
  return data; // { ok, remitoc }
};

// ✅ CREAR (POST /remitocs)
export const postRemitoc = async (payload) => {
  const url = p("remitocs"); log(url);
  const { data } = await API.post(url, payload, auth());
  return data; // { ok, remitoc }
};

// ✅ ACTUALIZAR (PUT /remitocs/:id)
export const putRemitoc = async (id, payload) => {
  const url = p(`remitocs/${id}`); log(url);
  const { data } = await API.put(url, payload, auth());
  return data; // { ok, remitoc }
};

// ✅ BORRADO LÓGICO (DELETE /remitocs/:id)
export const deleteRemitoc = async (id) => {
  const url = p(`remitocs/${id}`); log(url);
  const { data } = await API.delete(url, auth());
  return data; // { ok, remitoc }
};
